<template>
    <Card :header="$t('personalSettings')" content-class="d-flex flex-wrap gap-column-3 child-flex-basis-100">

        <FormValidator :validator="$v.form.profile.firstName" form-group v-slot="slotProps" :label="$t('firstName')" class="flex-basis-40 flex-grow-1 flex-shrink-0 width-min-200">
            <b-form-input v-model="form.profile.firstName" :disabled="busy" :state="slotProps.state" />
        </FormValidator>

        <FormValidator :validator="$v.form.profile.lastName" form-group v-slot="slotProps" :label="$t('lastName')" class="flex-basis-40 flex-grow-1 flex-shrink-0 width-min-200">
            <b-form-input v-model="form.profile.lastName" :disabled="busy" :state="slotProps.state" />
        </FormValidator>

        <FormValidator :validator="$v.form.email" form-group v-slot="slotProps" :label="$t('email')" class="flex-basis-40 flex-grow-1 flex-shrink-0 width-min-200">
            <b-form-input v-model="form.email" :disabled="busy" :state="slotProps.state" />
        </FormValidator>

        <FormValidator :validator="$v.form.profile.phone" form-group v-slot="slotProps" :label="$t('phoneNumber')" class="flex-basis-40 flex-grow-1 flex-shrink-0 width-min-200">
            <b-form-input v-model="form.profile.phone" :disabled="busy" :state="slotProps.state" />
        </FormValidator>

        <FormValidator :validator="$v.form.news" form-group v-slot="slotProps" :label="$t('notifications')">
            <b-form-select v-model="form.news" :options="optionsNotifications" :disabled="busy" :state="slotProps.state" />
        </FormValidator>

        <FormValidator :validator="$v.form.profile.language" form-group v-slot="slotProps" :label="$t('language2')">
            <b-form-select v-model="form.profile.language" :options="optionsLanguage" :disabled="busy" :state="slotProps.state" />
        </FormValidator>

        <FormValidator :validator="$v.form.demo" form-group v-slot="slotProps" :label="$t('demo')">
            <b-form-select v-model="form.demo" :options="optionsDemo" :disabled="busy" :state="slotProps.state" />
        </FormValidator>

        <div class="d-flex gap-3 mt-5">
            <ButtonIcon :loading="saving" :disabled="busy" class="wide" @click="formSubmit()">
                {{ $t('save') }}
            </ButtonIcon>
        </div>

    </Card>
</template>



<script>
    import FormValidator from '@/components/common/FormValidator.vue';
    import { required, email } from 'vuelidate/lib/validators';
    import formBackendValidationMixin from '@/mixins/formBackendValidationMixin';
    import { deepMergeWithFilter, scrollToElement } from '@/utils/util';
    import cloneDeep from 'lodash/cloneDeep';

    const FORM_DEFAULT_DATA = Object.freeze({
        email: '',
        demo: null,
        news: null,
        profile: {
            language: null,
            firstName: '',
            lastName: '',
            phone: '',
        },
    });

    export default {
        name: 'PersonalSettings',
        mixins: [formBackendValidationMixin],
        components: {
            FormValidator,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                request: this.parentComponent.requestUser,
                form: cloneDeep(FORM_DEFAULT_DATA),
                formValidations: {
                    form: {
                        email: { required, email },
                        demo: {},
                        news: {},
                        profile: {
                            firstName: { required },
                            lastName: { required },
                            language: {},
                            phone: {},
                        },
                    },
                },
            };
        },
        computed: {
            user() {
                return this.parentComponent.user;
            },
            notifications() {
                return this.parentComponent.requestUserNotifications.getData();
            },
            loading() {
                return this.parentComponent.requestUser.getLoading() || this.parentComponent.requestUserNotifications.getLoading();
            },
            saving() {
                return this.request.getLoading('patch');
            },
            busy() {
                return this.loading || this.saving;
            },
            optionsNotifications() {
                return [
                    { text: this.$t('notifyMe'), value: true },
                    { text: this.$t('doNotNotifyMe'), value: false },
                ];
            },
            optionsLanguage() {
                return [
                    { text: this.$t('english'), value: 'en' },
                    { text: this.$t('polish'), value: 'pl' },
                ];
            },
            optionsDemo() {
                return [
                    { text: this.$t('enabled'), value: true },
                    { text: this.$t('disabled'), value: false },
                ];
            },
        },
        watch: {
            user(data, oldData) {
                if (data && data !== oldData) this.initFormData(data);
            },
            notifications(data, oldData) {
                if (data && data !== oldData) this.initFormData(data);
            },
        },
        methods: {
            initFormData() {
                this.form = deepMergeWithFilter(FORM_DEFAULT_DATA, { ...(this.user || {}), ...(this.notifications || {}) });
            },
            async formSubmit() {
                this.$v.form.$touch();
                if (this.$v.form.$invalid) {
                    await this.$nextTick();
                    scrollToElement('.is-invalid', { offset: -80 });
                    return;
                }
                this.request
                    .id('patch')
                    .patch({ urlParams: { id: this.user.id }, requestParams: this.form })
                    .then(() => {
                        this.parentComponent.updateUser();
                        this.parentComponent.updateLanguage();
                        this.$toastr.success(this.$t('dataSavedSuccessfully'));
                        this.$v.form.$reset();
                    })
                    .catch(this.handleBackendValidations);
            },
        },
    };
</script>
